import {NgModule} from '@angular/core';
import {ModalComponent} from './modal/modal.component';
import {ModalDialogComponent} from './modal/modal-dialog/modal-dialog.component';
import {ModalDialogContentComponent} from './modal/modal-dialog/modal-dialog-content/modal-dialog-content.component';
import {ActionsModule} from '../actions/actions.module';
import {IconsModule} from '../icons/icons.module';
import {ModalService} from './modal/modal.service';

@NgModule({
    declarations: [
        ModalComponent,
        ModalDialogComponent,
        ModalDialogContentComponent
    ],
    entryComponents: [
        ModalComponent
    ],
    exports: [
        ModalComponent,
        ModalDialogComponent,
        ModalDialogContentComponent
    ],
    imports: [
        ActionsModule,
        IconsModule
    ],
    providers: [
        ModalService
    ]
})
export class ModalsModule {
}
